import VoucherGroups from './VoucherGroups'

export default VoucherGroups;


// WEBPACK FOOTER //
// ./src/components/Query/VoucherGroups/index.ts